/**
 * Dynamite brand theme overrides.
 * Deep-merged on top of the shared base theme via extendTheme.
 * TODO: Add component-level style overrides specific to Dynamite.
 */
import colors from './colors'
import fonts from './fonts'
import {textStyles} from './foundations/typography'

// Project Component style overrides
import TopBar from './components/project/top-bar'
import ListMenu from './components/project/list-menu'
import Cart from './components/project/cart'
import UgcExpandedPage from './components/project/ugc-expanded-page'
import UgcLandingPage from './components/project/ugc-landing-page'
import UgcCarouselHeader from './components/project/ugc-carousel-header'
import UgcPdpCarousel from './components/project/ugc-pdp-carousel'
import ForYouPage from './components/project/for-you-page'
import Text from './components/base/text'
import Button from './components/base/button'

export default {
    colors,
    fonts,
    textStyles,
    brandId: 'dynamite',
    components: {
        TopBar,
        ListMenu,
        Cart,
        UgcExpandedPage,
        UgcLandingPage,
        UgcCarouselHeader,
        UgcPdpCarousel,
        ForYouPage,
        Text,
        Button
    }
}
